import React from 'react'

interface FormBadgeProps {
  form: string | null | undefined
  maxResults?: number
  size?: 'sm' | 'md'
}

/**
 * Displays a team's recent form as color-coded badges.
 * W = Win (green), D = Draw (yellow), L = Loss (red)
 */
export function FormBadge({ form, maxResults = 5, size = 'sm' }: FormBadgeProps) {
  if (!form) return null

  const results = form.slice(-maxResults).split('')
  const badgeSize = size === 'sm' ? 14 : 18
  const fontSize = size === 'sm' ? 8 : 10

  return (
    <div className="form-badges">
      {results.map((char, i) => (
        <span
          key={i}
          className={`form-badge form-${char.toLowerCase()}`}
          style={{
            width: badgeSize,
            height: badgeSize,
            fontSize,
          }}
        >
          {char}
        </span>
      ))}
    </div>
  )
}
